import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdateSection() {
  const latest = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              <i className="ri-timer-line text-primary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪热门韩漫最新章节</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/50 transition-colors group"
            >
              <div className="w-16 h-20 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  更新至 {comic.chapters.length} 话
                </p>
                <div className="flex items-center gap-1 mt-1.5">
                  <span className={`inline-block px-1.5 py-0.5 rounded text-xs ${
                    comic.status === '连载中'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.status}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}